var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___LU03RE",
  "jf": "VoiceConnectionStatus.module__statusRow___LU03RE",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___LU03RE",
  "kR": "VoiceConnectionStatus.module__signalIcon___LU03RE",
  "rI": "VoiceConnectionStatus.module__statusButton___LU03RE",
  "QQ": "VoiceConnectionStatus.module__statusConnected___LU03RE",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___LU03RE",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___LU03RE",
  "ne": "VoiceConnectionStatus.module__controls___LU03RE",
  "uH": "VoiceConnectionStatus.module__controlButton___LU03RE",
  "wH": "VoiceConnectionStatus.module__selected___LU03RE",
  "Kk": "VoiceConnectionStatus.module__icon___LU03RE",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___LU03RE",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___LU03RE",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___LU03RE",
  "_R": "VoiceConnectionStatus.module__channelSourceText___LU03RE",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___LU03RE",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___LU03RE",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___LU03RE",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___LU03RE",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___LU03RE",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___LU03RE",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___LU03RE",
  "EU": "VoiceConnectionStatus.module__mediaSection___LU03RE",
  "LA": "VoiceConnectionStatus.module__mediaButton___LU03RE",
  "A1": "VoiceConnectionStatus.module__cameraActive___LU03RE",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___LU03RE",
  "oz": "VoiceConnectionStatus.module__roomActive___LU03RE",
  "cU": "VoiceConnectionStatus.module__mediaIcon___LU03RE",
  "DO": "VoiceConnectionStatus.module__roomNewBadge___LU03RE",
  "Cx": "VoiceConnectionStatus.module__roomNewBadgeShimmer___LU03RE",
  "jC": "VoiceConnectionStatus.module__popoutContainer___LU03RE",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___LU03RE",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___LU03RE",
  "hY": "VoiceConnectionStatus.module__popoutHeader___LU03RE",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___LU03RE",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___LU03RE",
  "nO": "VoiceConnectionStatus.module__popoutStats___LU03RE",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___LU03RE",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___LU03RE",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___LU03RE",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___LU03RE",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___LU03RE",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___LU03RE",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___LU03RE",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___LU03RE",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___LU03RE",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___LU03RE",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___LU03RE",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___LU03RE",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___LU03RE",
  "mp": "VoiceConnectionStatus.module__deviceBadge___LU03RE",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___LU03RE",
  "hn": "VoiceConnectionStatus.module__endpointBadge___LU03RE",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___LU03RE",
  "_v": "VoiceConnectionStatus.module__chartContainer___LU03RE",
  "nS": "VoiceConnectionStatus.module__chartSvg___LU03RE",
  "$s": "VoiceConnectionStatus.module__gridLine___LU03RE",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___LU03RE",
  "eB": "VoiceConnectionStatus.module__gridText___LU03RE",
  "BC": "VoiceConnectionStatus.module__chartLine___LU03RE",
  "Pi": "VoiceConnectionStatus.module__chartPoint___LU03RE",
  "Hh": "VoiceConnectionStatus.module__textGreen___LU03RE",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___LU03RE",
  "Bx": "VoiceConnectionStatus.module__iconSmall___LU03RE",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___LU03RE",
  "hz": "VoiceConnectionStatus.module__lockIcon___LU03RE",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___LU03RE",
  "uU": "VoiceConnectionStatus.module__nsOptions___LU03RE",
  "Ot": "VoiceConnectionStatus.module__nsSliderSection___LU03RE",
  "Pq": "VoiceConnectionStatus.module__nsSliderLabel___LU03RE",
  "nj": "VoiceConnectionStatus.module__nsSliderTitleRow___LU03RE",
};

module.exports = exports;
